module.exports = __webpack_public_path__ + "img/xxyfjg.8f7d81c.png";